import maxBy from "lodash/maxBy";
import { createSelector } from "reselect";
import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { timeToMoment } from "rivals/shared/utils/listVersions";
import { State } from "./reducer";

export const getListState = (state: AppState): State => state[StateKeys.LIST];

export const getAvailableYears = createSelector(
  getListState,
  state => state.availableYears
);

export const getError = createSelector(getListState, state => state.error);

export const getList = createSelector(getListState, state => state.list);

export const getListVersions = createSelector(
  getListState,
  state => state.versions
);

export const selectLatestVersion = createSelector(getListState, state =>
  maxBy(state.versions, v => timeToMoment(v, "liveAt"))
);

export const selectCurrentVersion = createSelector(getListState, state =>
  state.versions?.find(v => v.listId === state.list?.listId)
);

export const getPeopleList = createSelector(
  getListState,
  state => state.people
);

export const getPeopleListCollegeFocus = createSelector(
  getListState,
  state => state.collegeFocus
);

export const getPeopleListSuccess = createSelector(
  getListState,
  state => state.peopleSuccess
);

export const getSubmitting = createSelector(
  getListState,
  state => state.submitting
);

export const getSuccess = createSelector(getListState, state => state.success);

export const getTotalPeople = createSelector(
  getListState,
  state => state.totalPeople
);

export const getValidFilters = createSelector(
  getListState,
  state => state.validFilters
);
